import ModifiUserLogo from './ModifiUserLogo'

export default ModifiUserLogo
